import { render, staticRenderFns } from "./processApi.vue?vue&type=template&id=caf61b52&scoped=true"
import script from "./processApi.vue?vue&type=script&lang=js"
export * from "./processApi.vue?vue&type=script&lang=js"
import style0 from "./processApi.vue?vue&type=style&index=0&id=caf61b52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf61b52",
  null
  
)

export default component.exports